import React, { useMemo, useState } from 'react';
import { Table, Badge, Progress, Avatar, Space, Skeleton } from 'antd';
import type { ColumnsType } from 'antd/es/table';

import { FaAngleRight, FaArrowRight, FaEye, FaPen, } from 'react-icons/fa6';
import { Order } from '../../Models/Order';
import { useNavigate } from 'react-router-dom';
import { CustomTag } from '../Tags/CustomTag';
import { addressStyles, paymentStyles, statusStyles } from '../Tags/TagConfig';


interface Props {
  products: Order[];
  pageSize: number;
  current: number;
  total: number;
  loading: boolean; 
  setPage: React.Dispatch<React.SetStateAction<number>>;
  onRefresh: () => void; // Para que la modal avise que terminó
}

const OrderAdminTable = ({ products, pageSize, current, total, loading, setPage, onRefresh }: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  
  // Datos ficticios para el Skeleton
  const skeletonData = useMemo(() => 
    Array.from({ length: pageSize }).map((_, i) => ({ id: `skeleton-${i}` } as unknown as Order)),
    [pageSize]
  );

  const columns: ColumnsType<Order> = useMemo(() => [
    {
      title: 'ORDEN',
      dataIndex: 'name',
      key: 'name',
      render: (_, record) => (
        loading ? (
          <Space size="middle">
            <Skeleton active title={false} paragraph={{ rows: 2, width: [150, 100] }} />
          </Space>
        ) : (
          <Space size="middle">
            <div>
              <div style={{ fontSize: '12px', color: '#8c8c8c' }}>#ORDER-{record.id}</div>
            </div>
          </Space>
        )
      ),
    },
    {
      title: 'STATUS',
      dataIndex: 'status',
      key: 'status',
      render: (_, record) => (
        loading ? <Skeleton.Button active size="small" style={{ width: 80, borderRadius: 12 }} /> : (
          <CustomTag value={record.status} config={statusStyles} />
        )
      ),
    },
    {
      title: 'TOTAL',
      dataIndex: 'total',
      key: 'total',
      render: (total, record) => (
        loading ? <Skeleton.Input active size="small" style={{ width: 60 }} /> : (
          <span style={{ fontWeight: 600 }}>${(total || 0)}</span>
        )
      ),
    },
    {
      title: 'METODO DE PAGO',
      dataIndex: 'paymentMethod',
      key: 'paymentMethod',
      render: (_, record) => (
        loading ? <Skeleton.Button active size="small" style={{ width: 80, borderRadius: 12 }} /> : (
          <CustomTag value={record.paymentMethod} config={paymentStyles} />
        )
      ),
    },
    {
      title: 'ENTREGA',
      dataIndex: 'type',
      key: 'type',
      render: (_, record) => (
        loading ? <Skeleton.Button active size="small" style={{ width: 80, borderRadius: 12 }} /> : (
          <CustomTag value={record.type} config={addressStyles} />
        )
      ),
    },

{
      title: 'ACTIONS',
      key: 'actions',
      render: (_, record) => loading ? null : (
        <Space size="middle">
          {/* <FaPen
            style={{ cursor: 'pointer', color: '#8c8c8c', fontSize: '18px' }} 
            // onClick={() => openEdit(record)} // Abrimos la modal pasándole el objeto
            title="Edición rápida"
          /> */}
          <FaAngleRight onClick={()=>{navigate(`/orden-admin/${record.id}`)}} style={{ cursor: 'pointer', color: '#8c8c8c', fontSize: '18px' }}  />
        </Space>
      ),
    }
  ], [loading]);

  const changePage = (pagination: any) => {
    if (pagination.current) {
      setPage(pagination.current);
    }
  };

  return (
    <>
    <Table 
      columns={columns} 
      dataSource={loading ? skeletonData : products} 
      rowKey={(record) => record.id}
      pagination={{
        current: current,
        pageSize: pageSize,
        total: total,
        showSizeChanger: false,
        position: ['bottomRight'],
      }}
      onChange={changePage}
      className="custom-product-table"
    />
    
    </>

  );
};

export default OrderAdminTable;